import React from "react";
import { Link, useLocation } from "react-router-dom";

const Navigation: React.FC = () => {
  const location = useLocation();

  const isActive = (path: string) => {
    return location.pathname === path;
  };

  return (
    <nav
      style={{
        backgroundColor: "#f8f9fa",
        padding: "1rem 0",
        borderBottom: "1px solid #e9ecef",
        marginBottom: "2rem",
      }}
    >
      <div
        style={{
          maxWidth: "1200px",
          margin: "0 auto",
          padding: "0 20px",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Link
          to="/"
          style={{
            textDecoration: "none",
            color: "#333",
            fontSize: "1.5rem",
            fontWeight: "bold",
          }}
        >
          Search & Match
        </Link>

        <div
          style={{
            display: "flex",
            gap: "2rem",
          }}
        >
          <Link
            to="/"
            style={{
              textDecoration: "none",
              color: isActive("/") ? "#007bff" : "#666",
              fontWeight: isActive("/") ? "bold" : "normal",
              padding: "0.5rem 1rem",
              borderRadius: "4px",
              transition: "all 0.2s ease",
            }}
          >
            Home
          </Link>
          <Link
            to="/privacy-policy"
            style={{
              textDecoration: "none",
              color: isActive("/privacy-policy") ? "#007bff" : "#666",
              fontWeight: isActive("/privacy-policy") ? "bold" : "normal",
              padding: "0.5rem 1rem",
              borderRadius: "4px",
              transition: "all 0.2s ease",
            }}
          >
            Privacy Policy
          </Link>
          <Link
            to="/terms-of-service"
            style={{
              textDecoration: "none",
              color: isActive("/terms-of-service") ? "#007bff" : "#666",
              fontWeight: isActive("/terms-of-service") ? "bold" : "normal",
              padding: "0.5rem 1rem",
              borderRadius: "4px",
              transition: "all 0.2s ease",
            }}
          >
            Terms of Service
          </Link>
          <Link
            to="/contact"
            style={{
              textDecoration: "none",
              color: isActive("/contact") ? "#007bff" : "#666",
              fontWeight: isActive("/contact") ? "bold" : "normal",
              padding: "0.5rem 1rem",
              borderRadius: "4px",
              transition: "all 0.2s ease",
            }}
          >
            Contact
          </Link>
        </div>
      </div>
    </nav>
  );
};

export default Navigation;
